import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import { InstrumentInfoStatusAlert } from './InstrumentInfoStatusAlert'
import { SurveyEntryActions } from './SurveyEntryActions'
import { SurveyEntryHeader } from './SurveyEntryHeader'
import { SurveyEntryScreen } from './SurveyEntryScreen'
import { SurveyEntryStatsGrid } from './SurveyEntryStatsGrid'
import type { InstrumentInfoEntryViewState, ProviderInstrumentInfo } from '../lib/types'
import type { SurveyAvailabilityBadge } from '../lib/instrument-info-state'
import {
  surveyEntryCardBodySx,
  surveyEntryStatusAlertSx,
} from '../styles/surveyEntryStyles'

export type InstrumentInfoReadyEntryProps = Readonly<{
  info: ProviderInstrumentInfo
  viewState: InstrumentInfoEntryViewState
  availabilityBadge: SurveyAvailabilityBadge
  startErrorMessage: string | null
  canStart: boolean
  canContinue: boolean
  startPending: boolean
  statusReady: boolean
  statusLoading: boolean
  onStartClick: () => void
  onContinueClick: () => void
}>

export function InstrumentInfoReadyEntry({
  info,
  viewState,
  availabilityBadge,
  startErrorMessage,
  canStart,
  canContinue,
  startPending,
  statusReady,
  statusLoading,
  onStartClick,
  onContinueClick,
}: InstrumentInfoReadyEntryProps) {
  return (
    <SurveyEntryScreen>
      <Box
        sx={surveyEntryCardBodySx}
        data-testid="survey-entry-card-body"
        data-survey-entry-card-body
      >
        <InstrumentInfoStatusAlert viewState={viewState} />

        <SurveyEntryHeader
          name={info.name}
          description={info.description}
          availability={availabilityBadge}
        />

        <SurveyEntryStatsGrid
          questionCount={info.questionCount}
          estimatedCompletionMinutes={info.estimatedCompletionMinutes}
          reward={info.reward}
        />

        {startErrorMessage ? (
          <Alert
            severity="error"
            sx={surveyEntryStatusAlertSx}
            data-testid="instrument-info-start-error"
          >
            {startErrorMessage}
          </Alert>
        ) : null}
      </Box>

      <SurveyEntryActions
        canStart={canStart}
        canContinue={canContinue}
        startPending={startPending}
        statusReady={statusReady}
        statusLoading={statusLoading}
        onStartClick={onStartClick}
        onContinueClick={onContinueClick}
      />
    </SurveyEntryScreen>
  )
}
